import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { PageFixAccessibilityChecksComponent } from './components/accessibility-checks/accessibility-checks.component';
import { PageFixChangesetCustomComponent } from './components/changeset/custom/page-fix-changeset-custom.component';
import { PageFixChecksComponent } from './pages/checks/checks.component';
import { PageFixAccessibilityChecksDesignComponent } from './pages/design/design.component';
import { PageFixAccessibilityChecksLinksComponent } from './pages/links/links.component';
import { PageFixListComponent } from './pages/list/list.component';
import { PageFixSummaryChangeTypesComponent } from './pages/summary/change-types/change-types.component';
import { PageFixSummaryDiagnosticsComponent } from './pages/summary/diagnostics/diagnostics.component';
import { PageFixSummaryTableComponent } from './pages/summary/table/table.component';
import { PageFixSummaryComponent } from './pages/summary/summary.component';
import { PageFixAccessibilityChecksWebsiteStructureComponent } from './pages/website-structure/website-structure.component';
import { LayoutModule, MonTableSortModule } from '@monsido/angular-shared-components';
import { TranslateModule } from '@client/app/modules/translate.module';
import { BarComponent } from '@client/app/modules/charts/components/bar.component';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { UIRouterModule } from '@uirouter/angular';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    schemas: [NO_ERRORS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        UpgradePipeModule,
        LayoutModule,
        TranslateModule,
        BarComponent,
        DoughnutComponent,
        UIRouterModule,
        MonTableSortModule,
        MonActionMenuModule,
        NgbTooltip,
    ],
    declarations: [
        PageFixAccessibilityChecksComponent,
        PageFixChangesetCustomComponent,
        PageFixChecksComponent,
        PageFixAccessibilityChecksDesignComponent,
        PageFixAccessibilityChecksLinksComponent,
        PageFixAccessibilityChecksWebsiteStructureComponent,
        PageFixListComponent,
        PageFixSummaryChangeTypesComponent,
        PageFixSummaryDiagnosticsComponent,
        PageFixSummaryTableComponent,
        PageFixSummaryComponent,
    ],
    exports: [
        PageFixAccessibilityChecksComponent,
        PageFixChangesetCustomComponent,
        PageFixChecksComponent,
        PageFixAccessibilityChecksDesignComponent,
        PageFixAccessibilityChecksLinksComponent,
        PageFixAccessibilityChecksWebsiteStructureComponent,
        PageFixListComponent,
        PageFixSummaryChangeTypesComponent,
        PageFixSummaryDiagnosticsComponent,
        PageFixSummaryTableComponent,
        PageFixSummaryComponent,
    ],
})
export class UpgradePageFixModule {}
